<template>
  <div class="agr">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <div class="container">
      <h2>用户协议</h2>
      <p>
        请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不进入 。当您注册成功，无论是进入，还是在本网站上发布任何内容（即「内容」），均意味着您（即「用户」）完全接受本协议项下的全部条款。
      </p>
      <h2>使用规则</h2>
      <p>
        用户注册成功后，将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。
      </p>
      <p>
        用户须对在 的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义发布任何信息；不得恶意使用注册帐号导致其他用户误认；否则
       有权立即停止提供服务，收回其帐号并由用户独自承担由此而产生的一切法律责任。
      </p>
      <p>
        用户直接或通过各类方式（如 RSS 源和站外 API 引用等）间接使用 服务和数据的行为，都将被视作已无条件接受本协议全部内容；若用户对本协议的任何条款存在异议，请停止使用
       所提供的全部服务。
      </p>
      <p>
       是一个信息分享、传播及获取的平台，用户通过 发表的信息为公开的信息，其他第三方均可以通过 获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任；任何用户不愿被其他第三人获知的信息都不应该在
       上进行发表。
      </p>
      <p>
        用户承诺不得以任何方式利用直接或间接从事违反中国法律以及社会公德的行为，有权对违反上述承诺的内容予以删除。
      </p>
      <p>
        用户不得利用服务制作、上载、复制、发布、传播或者转载如下内容：
        反对宪法所确定的基本原则的；
        危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； 损害国家荣誉和利益的；
        煽动民族仇恨、民族歧视，破坏民族团结的；
        侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的；
        破坏国家宗教政策，宣扬邪教和封建迷信的； 散布谣言，扰乱社会秩序，破坏社会稳定的；
        散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
        侮辱或者诽谤他人，侵害他人合法权益的； 含有法律、行政法规禁止的其他内容的信息。
      </p>
      <p>所有用户同意遵守社区管理规定。</p>
      <p>
       有权对用户使用的情况进行审查和监督，如用户在使用 时违反任何上述规定，有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容、暂停或终止用户使用
       的权利）以减轻用户不当行为造成的影响。
      </p>

      <h2>知识产权</h2>

      <p>
       是一个信息获取、分享及传播的平台，我们尊重和鼓励 用户创作的内容，认识到保护知识产权对 生存与发展的重要性，承诺将保护知识产权作为运营的基本原则之一。
      </p>
      <p>
        用户在 上发表的全部原创内容（包括但不仅限于回答、文章和评论），著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要得到
       的同意。
      </p>
      <p>
        提供的网络服务中包含的标识、版面设计、排版方式、文本、图片、图形等均受著作权、商标权及其它法律保护，未经相关权利人（含
        及其他原始权利人）同意，上述内容均不得在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。
      </p>
      <p>
        为了促进知识的分享和传播，用户将其在上发表的全部内容，授予 免费的、不可撤销的、非独家使用许可，有权将该内容用于 各种形态的产品和服务上，包括但不限于网站以及发表的应用或其他互联网产品。
      </p>
      <p>
        第三方若出于非商业目的，将用户在上发表的内容转载在 之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在 上使用的帐号名称），给出原始链接，注明「发表于 」，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系用户获得单独授权，按照用户规定的方式使用该内容。
      </p>
           <p>
        在 上传或发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给 或任何第三方造成损失的，用户应负责全额赔偿。
      </p>
      <p>
        如果任何第三方侵犯了用户相关的权利，用户同意授权或其指定的代理人代表
        自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在
       认为必要的情况下参与共同维权。
      </p>
      <p>
       有权但无义务对用户发布的内容进行审核，有权根据相关证据结合法律法规及 社区指导原则对侵权信息进行处理。
      </p>

      <h2>个人隐私</h2>
      <p>尊重用户个人隐私信息的私有性是 本网的一贯原则，本网将通过技术手段、强化内部管理等办法充分保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或事先得到用户明确授权等原因外，本网保证不对外公开或向第三方透露用户个人隐私信息，或用户在使用服务时存储的非公开内容。同时，为了运营和改善 本网的技术与服务，本网将可能会自行收集使用或向第三方提供用户的非个人隐私信息，这将有助于 本网向用户提供更好的用户体验和服务质量。</p>

      <h2>免责声明</h2>
      <p>本网不能对用户发表的回答或评论的正确性进行保证。</p>
      <p>用户在 本网发表的内容仅表明其个人的立场和观点，并不代表 本网的立场或观点。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。本网不承担任何法律及连带责任。</p>
      <p>本网不保证网络服务一定能满足用户的要求，也不保证网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。</p>
      <p>对于因不可抗力或 本网不能控制的原因造成的网络服务中断或其它缺陷，本网不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。 协议修改</p>
      <p>根据互联网的发展和有关法律、法规及规范性文件的变化，或者因业务发展需要，本网有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，本网将会直接在 本网网站上公布修改之后的协议内容，该公布行为视为 本网已经通知用户修改内容。本网也可采用电子邮件或私信的传送方式，提示用户协议条款的修改、服务变更、或其它重要事项。</p>
      <p>如果不同意 本网对本协议相关条款所做的修改，用户有权并应当停止使用 本网。如果用户继续使用 本网，则视为用户接受 本网对本协议相关条款所做的修改。</p>
      <div class="blink"></div>

     
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/h2";
export default {
  name: "agreement",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "晋江奇境 ";
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.agr {
  .container {
    width: 980px;
    padding-top: 30px;
    h2 {
      font-size: 21px;
      font-weight: bold;
      color: #333;
    }

    p {
      text-indent: 30px;
      font-size: 14px;
      line-height: 31px;
      margin: 20px 0 40px;
      color: #888;
    }

    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin: 15px 0;
      span {
        font-size: 14px;
        color: #888;
        font-weight: normal;
      }
    }

    .blink {
      width: 100%;
      height: 1px;
      background: #ccc;
      margin-bottom: 30px;
    }
  }
}
</style>
